import dynamic from 'next/dynamic'

export const FeatureHero = dynamic(() => import('./feature-hero'))
